import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\SendDossierAttachmentToEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDossierAttachmentToEnaosController.php
* @route '/api/dossier/{dossier}/media/{media}/enaos'
*/
const SendDossierAttachmentToEnaosController = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendDossierAttachmentToEnaosController.url(args, options),
    method: 'post',
})

SendDossierAttachmentToEnaosController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/media/{media}/enaos',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\SendDossierAttachmentToEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDossierAttachmentToEnaosController.php
* @route '/api/dossier/{dossier}/media/{media}/enaos'
*/
SendDossierAttachmentToEnaosController.url = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return SendDossierAttachmentToEnaosController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\SendDossierAttachmentToEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDossierAttachmentToEnaosController.php
* @route '/api/dossier/{dossier}/media/{media}/enaos'
*/
SendDossierAttachmentToEnaosController.post = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendDossierAttachmentToEnaosController.url(args, options),
    method: 'post',
})

export default SendDossierAttachmentToEnaosController